import React from "react";

interface SearchIconProps {
  width?: string;
  height?: string;
  fill?: string;
}

const SearchIcon: React.FC<SearchIconProps> = ({
  width = "24px",
  height = "24px",
  fill = "currentColor",
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="11" cy="11" r="8" stroke={fill} strokeWidth="2" />
      <path
        d="m21 21-4.35-4.35"
        stroke={fill}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SearchIcon;
